/**
 * Aelo Public Runtime Configuration
 * Only public values. No secrets.
 */

function normalizePublicUrl(value: string | undefined, opts?: { allowRelative?: boolean; stripTrailingSlash?: boolean }): string | null {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed) return null
  if (/^(javascript|data|vbscript):/i.test(trimmed)) return null

  if (opts?.allowRelative && /^(\/|\.|#)/.test(trimmed)) {
    return opts.stripTrailingSlash ? trimmed.replace(/\/+$/, '') : trimmed
  }

  try {
    const baseOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    const url = new URL(trimmed, baseOrigin)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null
    const out = url.href
    return opts?.stripTrailingSlash ? out.replace(/\/+$/, '') : out
  } catch {
    return null
  }
}

const SHOPIFY_STORE_URL = normalizePublicUrl(import.meta.env.VITE_SHOPIFY_STORE_URL, { stripTrailingSlash: true }) ?? 'https://shop.aelofilter.com'
const SHOPIFY_MEMBERSHIP_PRODUCT_URL = normalizePublicUrl(import.meta.env.VITE_SHOPIFY_MEMBERSHIP_PRODUCT_URL, { stripTrailingSlash: true })
  ?? `${SHOPIFY_STORE_URL}/products/aelo-straw-filter-monthly-refill-pack?variant=57855751553411`

export const AELO_CONFIG = Object.freeze({
  EDGE_FN_BASE: normalizePublicUrl(import.meta.env.VITE_EDGE_FN_BASE, { stripTrailingSlash: true }) ?? 'http://127.0.0.1:54321/functions/v1',
  PUBLIC_SITE_URL: normalizePublicUrl(import.meta.env.VITE_PUBLIC_SITE_URL, { stripTrailingSlash: true }) ?? 'http://localhost:5173',
  INVITE_BASE_URL: normalizePublicUrl(import.meta.env.VITE_INVITE_BASE_URL, { stripTrailingSlash: true }) ?? 'http://localhost:5173/invite',
  DASHBOARD_URL: normalizePublicUrl(import.meta.env.VITE_DASHBOARD_URL, { allowRelative: true }) ?? '/dashboard',
  COMPLETE_PROFILE_URL: normalizePublicUrl(import.meta.env.VITE_COMPLETE_PROFILE_URL, { allowRelative: true }) ?? '/complete-profile',
  AUTH_REDIRECT_URL: normalizePublicUrl(import.meta.env.VITE_AUTH_REDIRECT_URL, { allowRelative: true }) ?? '/auth/callback',
  SHOPIFY_STORE_URL,
  SHOPIFY_MEMBERSHIP_PRODUCT_URL,
  SUPABASE_URL: normalizePublicUrl(import.meta.env.VITE_SUPABASE_URL, { stripTrailingSlash: true }) ?? '',
  SUPABASE_ANON_KEY: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  GOOGLE_MAPS_API_KEY: (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ?? '',
})

export function getConfigValue<K extends keyof typeof AELO_CONFIG>(key: K): (typeof AELO_CONFIG)[K] {
  return AELO_CONFIG[key]
}
